import React from 'react';
import {
  PaymentTermsContainer,
  LabelRow,
  ConditionLabel,
  PaymentTermBadge
} from './styles';

interface PaymentTermsInfoProps {
  paymentCondition: string;
}

const PaymentTermsInfo = ({ paymentCondition }: PaymentTermsInfoProps) => {
  return (
    <PaymentTermsContainer>
      <LabelRow>
        <ConditionLabel>Condição de pagamento</ConditionLabel>
      </LabelRow>
      <PaymentTermBadge>{paymentCondition}</PaymentTermBadge>
    </PaymentTermsContainer>
  );
};

export default PaymentTermsInfo;
